// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-module--checkbox--19RMS","checkmark":"checkbox-module--checkmark--2ro04"};